// extracted by mini-css-extract-plugin
export default {"Box":"table-group-contents-module__Box--lvCP9","disabledFooter":"table-group-contents-module__disabledFooter--SY7Ek"};